import { skipToken, useSuspenseQuery } from '@apollo/client';

import type { SerpsListItem } from '@xing-com/crate-jobs-domain-serps-constants';
import { GetJobDetailsLinkboxesDocument } from '@xing-com/crate-jobs-graphql';

type UseSeoLinkBoxes = {
  linkboxes?: {
    kind: string;
    entries: SerpsListItem[];
  }[];
  error?: Error;
};

const allowedLinkboxes: string[] = ['nearby_job_role', 'related_job_roles'];

export const useJobDetailsLinkBoxes = ({
  location,
  jobRole,
}: {
  location?: string;
  jobRole: string;
}): UseSeoLinkBoxes => {
  const { data, error } = useSuspenseQuery(
    GetJobDetailsLinkboxesDocument,
    !jobRole || !location
      ? skipToken
      : {
          variables: {
            jobRole,
            location: location?.toLocaleLowerCase().replace(/\s/g, '-'),
          },
          errorPolicy: 'all',
        }
  );

  const serialized = [
    ...(data?.jobRoleLinkboxes?.collection || []),
    ...(data?.localJobRoleLinkboxes?.collection || []),
  ].map((item) => {
    if (
      item === null ||
      item.entries === null ||
      !allowedLinkboxes.includes(item.kind)
    ) {
      return null;
    }

    return {
      kind: item.kind,
      entries: item.entries.map((entry) => ({
        id: entry?.name || '',
        link: { url: entry?.url || '', label: entry?.name || '' },
        count: entry?.jobCount || 0,
      })),
    };
  });

  return {
    linkboxes: serialized?.filter((item) => item !== null),
    error,
  };
};
